var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "btn-back",
      attrs: { href: _vm.link },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.clickHandler($event)
        }
      }
    },
    [
      _c(
        "svg",
        { attrs: { width: "12", height: "12", viewBox: "0 0 12 12" } },
        [
          _c("path", {
            attrs: {
              d:
                "M12 .8l-.8-.8L6 5.2.8 0 0 .8 5.2 6 0 11.2l.8.8L6 6.8l5.2 5.2.8-.8L6.8 6z"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45324f50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45324f50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/BtnBack.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-45324f50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/BtnBack.vue
// module chunks = 1 2